import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { AuthService } from '../login/auth.service';
import {
  AddInfoRowDto,
  AddProductToCarDto,
  CarModelType,
  CreateCarModelTypeDto,
  Folder,
  InfoRow,
  ProductInCarDto,
  RemoveProductFromCarDto,
  SearchCarModelTypeDto,
  UpdateCarModelTypeDto,
  UpdateInfoRowDto
} from 'src/typings';

@Injectable({
  providedIn: 'root'
})
export class CarModelTypeService {
  constructor(private http: HttpClient, private authService: AuthService, private socket: Socket) {}

  carModelTypeGw = this.socket.fromEvent('CarModelTypeChange');

  carModelTypeProductGw = this.socket.fromEvent<{ car_id: number }>('carProductsUpdated');

  create(payload: CreateCarModelTypeDto) {
    return this.http.post<CarModelType>(`${environment.BACKEND}/car-model-type/create`, payload);
  }

  update(payload: UpdateCarModelTypeDto) {
    return this.http.put<CarModelType>(`${environment.BACKEND}/car-model-type/update`, payload);
  }

  search(payload?: SearchCarModelTypeDto) {
    return this.http
      .post<{ data: CarModelType[]; length: number }>(
        `${environment.BACKEND}/car-model-type/search`,
        payload
      )
      .pipe(
        map((row) => {
          return {
            ...row,
            data: row.data.map((row2) => {
              return {
                ...row2,
                manufacture_date_from: new Date(row2.manufacture_date_from),
                manufacture_date_to: row2.manufacture_date_to
                  ? new Date(row2.manufacture_date_to)
                  : new Date()
              };
            })
          };
        })
      );
  }

  getOne(id: number): Observable<CarModelType> {
    return this.http.get<CarModelType>(`${environment.BACKEND}/car-model-type/${id}`);
  }

  addInfoRow(payload: AddInfoRowDto) {
    return this.http.post<InfoRow[]>(`${environment.BACKEND}/car-model-type/add_info_row`, payload);
  }

  updateInfoRow(payload: UpdateInfoRowDto) {
    return this.http.put<InfoRow[]>(
      `${environment.BACKEND}/car-model-type/update_info_row`,
      payload
    );
  }

  removeInfoRow(id: number) {
    return this.http.delete<InfoRow[]>(
      `${environment.BACKEND}/car-model-type/remove_info_row/${id}`
    );
  }

  addProductToCar(payload: AddProductToCarDto) {
    return this.http.put<CarModelType>(
      `${environment.BACKEND}/car-model-type/add_product`,
      payload
    );
  }

  removeProductFromCar(payload: RemoveProductFromCarDto) {
    return this.http.put<CarModelType>(
      `${environment.BACKEND}/car-model-type/remove_product`,
      payload
    );
  }

  getCatalogueFolders(car_id: number) {
    return this.http.get<Folder[]>(`${environment.BACKEND}/car-model-type/folders/${car_id}`);
  }

  productInCar(payload: ProductInCarDto): Observable<number[]> {
    return this.http.post<number[]>(
      `${environment.BACKEND}/car-model-type/product_in_car`,
      payload
    );
  }
}
